import { ref } from 'vue'

// Current on-screen width of the left drawer, published by SidebarPanel so map
// overlays (timeline, footer) can sit next to it instead of underneath it — the
// panel is `fixed` at a higher z-index than the overlay column, so anything
// starting at the map's left edge is hidden behind it.
const panelWidth = ref(0)

export const useSidebarPanelWidth = () => panelWidth
